import { getBooleanAnswerOptions } from '@app/constants';
import { AnswerType, QuestionDependencyView, QuestionView } from '@data/sdk/match';

export const getBooleanFormInitialValues = (
  dependency: QuestionDependencyView,
  answerType: AnswerType,
) => ({
  source: { label: dependency?.text, value: dependency?.sourceId },
  applicableAnswer: getBooleanAnswerOptions().find((v) => v.value === dependency?.parameters[0])
    ?.value,
  notApplicableAnswer: getBooleanAnswerOptions().find((v) => v.value !== dependency?.parameters[0])
    ?.value,
  defaultValue:
    answerType === AnswerType.Boolean
      ? getBooleanAnswerOptions().find((v) => v.value === dependency?.parameters[1])?.value ?? ''
      : dependency.parameters[1],
});

export const getBooleanFormInitialValuesFromQuestion = (question: QuestionView) => ({
  source: { label: question?.text, value: question?.id },
});
